import Form from "./Components/Form";
import Loading from "./Components/Loading";
const App = () => {
  // const { waiting, loading, index, questions, nextQuestion, checkAnswer } =
  //   useGlobalContext();

  // if (waiting) {
  //   return <Form />;
  // }
  // if (loading) {
  //   return <Loading />;
  // }

  // const { incorrect_answers, correct_answer, question } = questions[index];
  // const answers = [...incorrect_answers];
  // if (incorrect_answers.length > 1) {
  //   let num = Math.floor(Math.random() * 4);
  //   if (num === 3) {
  //     answers.push(correct_answer);
  //   } else {
  //     answers.push(answers[num]);
  //     answers[num] = correct_answer;
  //   }
  // } else {
  //   let num = Math.floor(Math.random() * 2);
  //   answers.push(answers[num]);
  //   answers[num] = correct_answer;
  // }
  return <Form />;
};

export default App;
